import Divider from '@material-ui/core/Divider';
import TabPanel from 'packages/common-ui/TabPanel';
import {CustomTabs, CustomTab} from 'packages/common-ui/CustomTabs';
import {useState, ChangeEvent} from 'react';
import useStyles from '../admin-styles';
import Players from './Players';
import Admins from './Admins';

const Accounts = () => {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState(0);

  const handleOnChangeTab = (_: ChangeEvent<{}>, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <div className={classes.acc_root}>
      <div>
        <CustomTabs value={selectedTab} onChange={handleOnChangeTab}>
          <CustomTab
            label="Jugadores"
            id="simple-tab-1"
            aria-controls="simple-tabpanel-1"
          />
          <CustomTab
            label="Administradores"
            id="simple-tab-2"
            aria-controls="simple-tabpanel-2"
          />
        </CustomTabs>
        <Divider />
        <TabPanel value={selectedTab} index={0}>
          <Players />
        </TabPanel>
        <TabPanel value={selectedTab} index={1}>
          <Admins />
        </TabPanel>
      </div>
    </div>
  );
};

export default Accounts;
